const IconMarketDataLiveStream = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.88 20.6399V9.11993H17.52V20.6399H16.08V13.9199H12.72V20.6399H11.28V11.5199H7.92V20.6399H6.48V13.9199H3.12V20.6399H0V21.5999H24V20.6399H20.88ZM4.08 20.6399V14.8799H5.52V20.6399H4.08ZM8.88 20.6399V12.4799H10.32V20.6399H8.88ZM13.68 20.6399V14.8799H15.12V20.6399H13.68ZM18.48 20.6399V10.0799H19.92V20.6399H18.48Z"
      fill="white"
    />
    <path
      d="M20.88 2.87993V2.39993H18.3624C18.0984 2.39993 17.8824 2.61593 17.8824 2.87993C17.8824 3.14393 18.0984 3.35993 18.3624 3.35993H19.2408L14.304 8.29673L9.59518 5.94233L3.37678 9.17513C3.14158 9.29753 3.05038 9.58793 3.17278 9.82313C3.25918 9.98873 3.42478 10.0823 3.59998 10.0823C3.67438 10.0823 3.75118 10.0655 3.82078 10.0271L9.60238 7.01993L14.4936 9.46553L19.9176 4.03913V4.91753C19.9176 5.18153 20.1336 5.39753 20.3976 5.39753C20.6616 5.39753 20.8776 5.18153 20.8776 4.91753V2.88233L20.88 2.87993Z"
      fill="white"
    />
    <path
      d="M5.51996 14.8799H4.07996V20.6399H5.51996V14.8799Z"
      fill="white"
      fillOpacity="0.7"
    />
    <path
      d="M10.32 12.4799H8.88V20.6399H10.32V12.4799Z"
      fill="white"
      fillOpacity="0.7"
    />
    <path
      d="M15.1201 14.8799H13.6801V20.6399H15.1201V14.8799Z"
      fill="white"
      fillOpacity="0.7"
    />
    <path
      d="M19.92 10.0799H18.48V20.6399H19.92V10.0799Z"
      fill="white"
      fillOpacity="0.7"
    />
  </svg>
);

export default IconMarketDataLiveStream;
